import { map } from 'lodash';
/**
 * API enum data for conversation topics.
 *
 * @example
 * const impact = metaConversationTopic[conversation.topic]?.displayName;
 *
 * Source: https://msrceng.visualstudio.com/Workflows/_git/Antimatter-Services?path=%2Fsrc%2FCommsHub%2FMicrosoft.Msrc.CommsHub.Models%2FEnum%2FTopic.cs
 */
export const metaConversationTopic = {
    Assessment: {
        displayName: 'Assessment',
        order: 0,
    },
    CaseStatus: {
        displayName: 'Case Status',
        order: 1,
    },
    Release: {
        displayName: 'Release',
        order: 2,
    },
    Bounty: {
        displayName: 'Bounty',
        order: 3,
    },
    Other: {
        displayName: 'Other',
        order: 4,
    },
};
/**
 * Pre-populate the dropdown options for conversation topics.
 */
export const conversationTopicOptions = map(metaConversationTopic, (data, key) => ({
    key,
    text: data.displayName,
}));
